/**
 * Brazilian Portuguese (pt-BR) mappings for Multiplas Modal
 */

export const multiplasModalPtBR = {
  // Header
  "xPicks Analysis": "Análise xPicks",
  "ANALYZING": "ANALISANDO",
  "PROCESSING": "PROCESSANDO",

  // Loading states
  "Getting best bets...": "Obtendo melhores apostas...",
  "Analyzing game data...": "Analisando dados do jogo...",
  "Calculating probabilities...": "Calculando probabilidades...",

  // Results header
  "Top": "Top",
  "High Probability Bets": "Apostas de Alta Probabilidade",

  // Bet types
  "OVER": "ACIMA",
  "UNDER": "ABAIXO",
  "SPREAD": "SPREAD",
  "MONEYLINE": "MONEYLINE",
  "BOTH TEAMS TO SCORE": "AMBAS EQUIPES MARCAM",
  "TOTAL GOALS": "TOTAL DE GOLS",
  "MATCH RESULT": "RESULTADO DA PARTIDA",
  "HANDICAP": "HANDICAP",
  "DOUBLE CHANCE": "DUPLA CHANCE",

  // Confidence levels
  "HIGH": "ALTA",
  "MEDIUM": "MÉDIA",
  "LOW": "BAIXA",

  // Reasoning labels
  "Reasoning": "Raciocínio",
  "Analysis": "Análise",

  // Error messages
  "Error": "Erro",
  "Failed to get predictions": "Falha ao obter previsões",
  "Unable to analyze game": "Não foi possível analisar o jogo",
  "No predictions available": "Nenhuma previsão disponível",

  // Close button
  "Close": "Fechar",

  // Empty state
  "No high probability bets found": "Nenhuma aposta de alta probabilidade encontrada",
  "Try analyzing another game": "Tente analisar outro jogo",

  // Common betting terms
  "Yes": "Sim",
  "No": "Não",
  "Home": "Casa",
  "Away": "Fora",
  "Draw": "Empate",
  "Win": "Vitória",
  "points": "pontos",
  "goals": "gols",
  "runs": "corridas",

  // Sport-specific
  "Football": "Futebol",
  "Soccer": "Futebol",
  "Baseball": "Beisebol",
  "Basketball": "Basquete",
  "NFL": "NFL",
  "NBA": "NBA",
  "MLB": "MLB",

  // Additional UI text
  "Powered by AI": "Alimentado por IA",
  "Best bets for this game": "Melhores apostas para este jogo",
  "Confidence": "Confiança",
  "Probability": "Probabilidade",
  "Value": "Valor",

  // Star Coins Purchase Modal (from MultiplasButton)
  "Get Star Coins": "Obter Star Coins",
  "Buy More to Keep Using": "Compre Mais para Continuar Usando",
  "xPicks costs": "xPicks custa",
  "per use after free spins": "por uso após giros grátis",
  "POPULAR": "POPULAR",
  "Sign in to use xPicks": "Entre para usar xPicks",
  "xPicks": "xPicks",
  "free remaining": "grátis restantes",
  "coins": "moedas",
  "Resets": "Reinicia",
  "soon": "em breve",

  // Analyze in Chat
  "Analyze in Chat": "Analisar no Chat",

  // Two-click confirmation
  "Use Free?": "Usar Grátis?",
  "Use free xPicks?": "Usar xPicks grátis?",
  "Spend 9 coins for xPicks?": "Gastar 9 moedas para xPicks?",
};